import React from 'react';
import { Switch, Route } from 'react-router-dom';
import CashInList from './List';
import cashInPath from './config';

const PoCashInRoutes = () => {
    return (
        <Switch>
            <Route path={cashInPath.base} exact component={CashInList} />
        </Switch>
    );
};

export default PoCashInRoutes;